import { useRef } from "react";
import { Box, Dialog, DialogContent, DialogTitle, DialogActions, Button } from "@mui/material";
import { Fan } from "../models";
import { ColumnDef } from "@arelia-components/ui-atoms/data-grid";
import { FormEditActions } from "@arelia-components/form/FormEditActions";
import GeneralEditableTableContainer, { GeneralEditableTableContainerApi } from "@arelia-components/general-editable-table/GeneralEditableTableContainer";
import { FANS_UPDATE_EVENT_NAME } from "../constant";
import AddIcon from '@mui/icons-material/Add';

export interface FansEditDialogProps {
  open: boolean;
  title: string;
  data: Fan[];
  apiRoute: string;
  columnConfig: ColumnDef[];

  onClose: () => void;
  getApiResponseMapper?: (data: Fan[]) => any[];
  postApiResponseMapper?: (rowData: any[]) => Fan[];
  headerComponent?: JSX.Element | undefined;
}

export function FansEditDialog({
  open,
  title,
  apiRoute,
  columnConfig,
  onClose,
}: FansEditDialogProps) {
  const apiRef = useRef<GeneralEditableTableContainerApi>();

  const onAddRow = () => apiRef.current?.addRow();
  const onSave = () => apiRef.current?.save();
  const mutationHandler = () => {
    const event = new CustomEvent(FANS_UPDATE_EVENT_NAME);
    window.dispatchEvent(event);
  };

  return (
    <Dialog
      onClose={onClose}
      open={open}
      maxWidth={"lg"}
      fullWidth
      PaperProps={{ sx: styles.dialogPaper }}
    >
      <DialogTitle sx={styles.dialogTitle}>
        <Box sx={styles.titleContent}>
          {title}
        </Box>
        <FormEditActions handleReset={onClose} handleSubmit={onSave} />
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        <GeneralEditableTableContainer<Fan[]>
          columnConfig={columnConfig as any[]}
          apiRef={apiRef}
          onMutationSuccess={mutationHandler}
          apiRoute={apiRoute}
          onAddRow={onAddRow}
          responseDataField={null}
          bulkSendAll={true}
          getUseTake={false}
          updateQueryPath={""}
          updateQueryMethod={"PUT"}
          deleteLocally={true}
          seeAllButton={false}
          addToEmpty={false}
        />
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>
        <Button
          variant="contained"
          color="primary"
          onClick={onAddRow}
          startIcon={<AddIcon/>}
        >
          Add New Fan
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const styles = {
  dialogPaper: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '90vh',
    minHeight: '60vh'
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: '1px solid',
    borderColor: 'divider',
    paddingBottom: 2
  },
  titleContent: {
    display: 'flex',
    alignItems: "center",
    gap: 2
  },
  dialogContent: {
    position: 'relative',
    padding: 2,
    paddingTop: 3,
    flexGrow: 1,
    overflow: 'auto'
  },
  dialogActions: {
    position: 'relative',
    backgroundColor: 'background.paper',
    borderTop: '1px solid',
    borderColor: 'divider',
    padding: 2,
    width: '100%',
    justifyContent: 'center',
  }
};
